// extracted by mini-css-extract-plugin
export default {"wrapper":"E8","container":"F8","title":"G8","carousel":"H8","review":"I8","name":"J8","rating":"K8","heading":"L8","body":"M8"};
    if(module.hot) {
      // 1713211528379
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  